module.exports = __webpack_public_path__ + "img/43ne.e9ce2de0.svg";